/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recovery_TitleInputs */

const en_us2_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muscle readiness`)
};

const pt_br2_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prontidão muscular`)
};

const es_419_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disposición muscular`)
};

const pt_pt2_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prontidão muscular`)
};

const fr_fr2_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disponibilité musculaire`)
};

const de_de2_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muskelbereitschaft`)
};

const it_it2_recovery_title = /** @type {(inputs: Recovery_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prontezza muscolare`)
};

/**
* | output |
* | --- |
* | "Muscle readiness" |
*
* @param {Recovery_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const recovery_title = /** @type {((inputs?: Recovery_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recovery_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_recovery_title(inputs)
	if (locale === "es-419") return es_419_recovery_title(inputs)
	if (locale === "pt-PT") return pt_pt2_recovery_title(inputs)
	if (locale === "fr-FR") return fr_fr2_recovery_title(inputs)
	if (locale === "de-DE") return de_de2_recovery_title(inputs)
	if (locale === "it-IT") return it_it2_recovery_title(inputs)
	return en_us2_recovery_title(inputs)
});
export { recovery_title as "recovery.title" }